import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Text, Button } from "@fragments";
import { LinkRounded, AddRounded } from "@mui/icons-material";
import LinkInfo from "../components/LinkInfo";

export default function Attachments({ value, onChange }) {
    const { t } = useTranslation("contentModals");
    const [attachments, setAttachments] = useState(value || []);

    useEffect(() => {
        setAttachments(value || []);
    }, [value]);

    function handleUpdateList(newList) {
        setAttachments(newList);
        onChange(newList);
    }

    return (
        <div className="mt-5">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="mb-2">
                <Text.h3
                    value={t("manageContent.attachments.title")}
                    left={<LinkRounded />}
                    grow
                    right={<Button
                        text={t("manageContent.attachments.addButton")}
                        size="medium"
                        startIcon={<AddRounded />}
                        color="overlay"
                        onClick={() => {
                            const copy = [...attachments];
                            copy.push({ text: "", url: "", open: true });
                            handleUpdateList(copy);
                        }}
                    />}
                />
            </div>

            {attachments.map((attachment, index) => (
                <LinkInfo
                    data={attachment}
                    key={index}
                    onUpdate={(newItem) => {
                        const copy = [...attachments];
                        copy[index] = newItem;
                        handleUpdateList(copy);
                    }}
                    onDelete={() => {
                        const copy = [...attachments];
                        copy.splice(index, 1);
                        handleUpdateList(copy);
                    }}
                />
            ))}
        </div>
    );
}
